export class InjectionTryoutOsModel {
  constructor({
    id,
    code,
    status,
    categoriaNome,
    productCode,
    productName,
    clientName,
    quantityProduced,
    quantityRefugo,
    quantityBorra,
    quantityGalho,
    dtFimPrevisto,
    produtos,
  }) {
    this.id = id;
    this.code = code;
    this.status = status;
    this.categoriaNome = categoriaNome;
    this.productCode = productCode ?? "";
    this.productName = productName ?? "";
    this.clientName = clientName ?? "";
    this.quantityProduced = quantityProduced ?? 0;
    this.quantityRefugo = quantityRefugo ?? 0;
    this.quantityBorra = quantityBorra ?? 0;
    this.quantityGalho = quantityGalho ?? 0;
    this.dtFimPrevisto = dtFimPrevisto ?? null;
    this.produtos = produtos ?? [];
  }

  /** Item mínimo da listagem pendente ({ id, codigo }). */
  static fromListJson(json) {
    return new InjectionTryoutOsModel({
      id: json.id,
      code: json.codigo,
    });
  }

  static fromJson(json) {
    const produtos = Array.isArray(json.produtos)
      ? json.produtos.map((p) => String(p ?? "").trim()).filter(Boolean)
      : [];

    return new InjectionTryoutOsModel({
      id: json.id,
      code: json.codigo,
      status: json.status,
      categoriaNome: json.categoria_nome,
      productCode: json.produto_cod,
      productName: json.produto_desc,
      clientName: json.cliente_nome,
      quantityProduced: json.qtProduzida ?? 0,
      quantityRefugo: json.qtRefugo ?? 0,
      quantityBorra: json.qtBorra ?? 0,
      quantityGalho: json.qtGalho ?? 0,
      dtFimPrevisto: json.dt_fim_previsto,
      produtos,
    });
  }
}
